import React, { useEffect, useRef } from 'react'

const BarChartPlot = ({ json = {} }) => {
  console.log(json)
  const chartRef = useRef(null) // Create a ref for the custom element

  useEffect(() => {
    // This code will run after the component mounts,
    // ensuring `chartRef.current` is not null
    if (chartRef.current) {
      chartRef.current.keys = json.keys
      chartRef.current.series = json.series
    }
    console.log('json', json)
  }, [json]) // Run this effect when `json` changes

  return (
    <one-ux-plot-chart
      style={{ width: '100%', height: '300px' }}
      ref={chartRef} // Assign the ref to the custom element
      label={'test'}></one-ux-plot-chart>
  )
}

export default BarChartPlot
